import { SKIP_LOGOUT_TIMER } from '@dynamika-shared/utils/development';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const env = Object.assign(import.meta.env, (window as any)?.dynamikaConfig);

const useApiMocks = localStorage.getItem('useApiMocks');
export const USE_API_MOCKS =
  window.location.hostname === 'localhost' &&
  useApiMocks !== null &&
  !!Number(useApiMocks);

export const VITE_ENV = env.VITE_ENV;

export let ENVIRONMENT: 'development' | 'uat' | 'production' = 'production';

export const IS_LOCALHOST = location.hostname === 'localhost';

if (location.hostname === 'localhost' || location.hostname.includes('dev')) {
  ENVIRONMENT = 'development';
}

if (location.hostname.includes('uat')) {
  ENVIRONMENT = 'uat';
}

export const getEnvVariables = () => {
  // for development purpose
  const isDisabled = SKIP_LOGOUT_TIMER;
  const isDebugMode = ENVIRONMENT === 'development' && isDisabled;

  const {
    VITE_API_BASE_URL,
    VITE_AUTH0_DOMAIN,
    VITE_AUTH0_CLIENT_ID,
    VITE_USER_LOGOUT_NOTIFICATION_TIMER,
    VITE_USER_LOGOUT_TIMER,
    VITE_AUTH0_CONNECTION,
    VITE_INTERCOM_APP_ID,
    VITE_INTERCOM_DOMAIN,
    FEATURE_FLAGS,
    VITE_TYPEFORM_SURVEY_API_KEY
  } = env;

  const API_BASE_URL = VITE_API_BASE_URL || '';
  const AUTH0_DOMAIN = VITE_AUTH0_DOMAIN;
  const AUTH0_CLIENT_ID = VITE_AUTH0_CLIENT_ID;

  const AUTH0_CONNECTION_TYPE = VITE_AUTH0_CONNECTION;
  const USER_LOGOUT_NOTIFICATION_TIMER = VITE_USER_LOGOUT_NOTIFICATION_TIMER;
  const USER_LOGOUT_TIMER = isDebugMode ? 0 : VITE_USER_LOGOUT_TIMER;

  const INTERCOM_APP_ID = VITE_INTERCOM_APP_ID;
  const INTERCOM_DOMAIN = VITE_INTERCOM_DOMAIN || 'https://api-iam.intercom.io';

  const TYPEFORM_SURVEY_API_KEY = VITE_TYPEFORM_SURVEY_API_KEY ?? '';

  return {
    API_BASE_URL,
    AUTH0_DOMAIN,
    ENVIRONMENT,
    AUTH0_CLIENT_ID,
    AUTH0_CONNECTION_TYPE,
    USER_LOGOUT_NOTIFICATION_TIMER,
    USER_LOGOUT_TIMER,
    USE_API_MOCKS,
    INTERCOM_APP_ID,
    INTERCOM_DOMAIN,
    FEATURE_FLAGS,
    TYPEFORM_SURVEY_API_KEY
  };
};
